import React, { FC } from "react";
import styles from "./viewButton.module.scss";
import { IViewButton } from "./viewButton.interface";
import { view_icon } from "@jat-med/assets";
import { useTranslation } from "react-i18next";

export const ViewButton: FC<IViewButton> = ({
  onClick,
  title = "buttons.view",
}) => {
  const { t } = useTranslation();
  return (
    <button className={styles.view_button} onClick={onClick} title={t(title)}>
      <img src={view_icon} alt="view_btn" />
    </button>
  );
};
